export const getInTouchMapper = {
    title: "Toda grande ideia merece virar realidade. Comece seu projeto com a gente.",
};
